import React from 'react';
import './LegalPages.css';

const FAQ = () => {
  return (
    <div className="legal-page">
      <section className="legal-header">
        <div className="legal-header-content">
          <h1>Frequently Asked Questions</h1>
          <p className="subtitle">Find answers to common questions about DocuAIHub</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="content-wrapper">
          <aside className="table-of-contents">
            <h3>Categories</h3>
            <ul>
              <li><a href="#general">General</a></li>
              <li><a href="#pricing">Pricing & Billing</a></li>
              <li><a href="#features">Features</a></li>
              <li><a href="#security">Security</a></li>
              <li><a href="#support">Support</a></li>
            </ul>
          </aside>

          <main className="main-content">
            <section id="general" className="content-section">
              <h2>General Questions</h2>
              
              <h3>What is DocuAIHub?</h3>
              <p>
                DocuAIHub is an AI-powered document management platform that helps you convert, edit, sign, 
                and analyze documents with advanced automation and artificial intelligence.
              </p>

              <h3>Do I need to install any software?</h3>
              <p>
                No! DocuAIHub is a web-based platform. You can access all features directly from your browser 
                without any downloads or installations.
              </p>

              <h3>What file formats are supported?</h3>
              <p>
                We support all major document formats including PDF, Word (DOC/DOCX), Excel (XLS/XLSX), 
                PowerPoint (PPT/PPTX), images (JPG, PNG), and many more.
              </p>
            </section>

            <section id="pricing" className="content-section">
              <h2>Pricing & Billing</h2>
              
              <h3>How much does DocuAIHub cost?</h3>
              <p>
                We offer flexible pricing plans to suit different needs. Visit our pricing page or 
                <a href="/lp/xbt1l"> subscribe now</a> to see current plans and features.
              </p>

              <h3>Can I cancel my subscription?</h3>
              <p>
                Yes, you can cancel your subscription at any time. EU customers have a 14-day cooling-off 
                period. See our <a href="/refund">Refund Policy</a> for details.
              </p>

              <h3>What payment methods do you accept?</h3>
              <p>
                We accept all major credit cards, debit cards, and other secure payment methods through 
                our payment processor.
              </p>
            </section>

            <section id="features" className="content-section">
              <h2>Features</h2>
              
              <h3>What AI features are available?</h3>
              <p>
                Our AI features include document summarization, translation, text extraction, data analysis, 
                voice narration, and intelligent content recognition.
              </p>

              <h3>How accurate is the document conversion?</h3>
              <p>
                Our conversion technology maintains 99%+ accuracy for formatting, layouts, and content. 
                Complex documents are processed with advanced algorithms to preserve quality.
              </p>

              <h3>Can I edit PDFs?</h3>
              <p>
                Yes! DocuAIHub includes comprehensive PDF editing tools including text editing, image insertion, 
                annotations, and more.
              </p>
            </section>

            <section id="security" className="content-section">
              <h2>Security & Privacy</h2>
              
              <h3>Is my data secure?</h3>
              <p>
                Absolutely. We use bank-level encryption (SSL/TLS) and are SOC2 certified. All documents 
                are automatically deleted from our servers within 24 hours.
              </p>

              <h3>Do you share my documents with anyone?</h3>
              <p>
                No. We never share your documents with third parties. Your files are processed securely 
                and deleted after processing. See our <a href="/privacy">Privacy Policy</a> for details.
              </p>

              <h3>Where are documents stored?</h3>
              <p>
                Documents are temporarily stored on secure servers during processing and automatically 
                deleted within 24 hours. You can also delete them manually immediately after processing.
              </p>
            </section>

            <section id="support" className="content-section">
              <h2>Support</h2>
              
              <h3>How do I get help?</h3>
              <p>
                Contact our support team at <a href="mailto:help@docuaihub.com">help@docuaihub.com</a> or 
                call +357 77788373. We respond within 24 hours.
              </p>

              <h3>Do you offer refunds?</h3>
              <p>
                Yes. EU customers have a 14-day right of withdrawal. Other refund requests are evaluated 
                case-by-case. See our <a href="/refund">Refund Policy</a> for complete details.
              </p>

              <h3>How do I delete my account?</h3>
              <p>
                Contact our support team at <a href="mailto:help@docuaihub.com">help@docuaihub.com</a> to 
                request account deletion. All your data will be permanently removed.
              </p>
            </section>

            <section className="content-section">
              <h2>Still Have Questions?</h2>
              <p>
                If you didn't find the answer you're looking for, please don't hesitate to contact us:
              </p>
              <ul>
                <li><strong>Email:</strong> <a href="mailto:help@docuaihub.com">help@docuaihub.com</a></li>
                <li><strong>Phone:</strong> +357 77788373</li>
              </ul>
            </section>
          </main>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
